import type { ReactNode } from 'react'

/**
 * Bara de filtre pe care o imparte fiecare ecran din ADM - `_filters.php`.
 *
 * Un singur loc, nu o copie pe ecran: filtrele sunt aceeasi intrebare pe toate,
 * iar o bara care exista in opt fisiere ajunge cu opt seturi usor diferite de
 * optiuni.
 *
 * FARA CAMP DE CLIENT. Platforma intreaba o data care client, sus, langa numele
 * omului, si scrie raspunsul in sesiune. Un al doilea selector aici raspundea
 * la o intrebare deja pusa, nu era de acord cu ea, si il facea pe cel din antet
 * sa para stricat. (Si tot de-aia serverul ia firma din jeton - vezi
 * `AdmFilters` - deci ecranul nici n-ar avea ce sa trimita.)
 */
export function AdmFilterBar({ children }: { children: ReactNode }) {
  return (
    <div className="adm-bar" id="admFilters">
      {children}
    </div>
  )
}

/** Un camp din bara. `wide` e `adm-field-wide` din macheta. */
export function AdmField({
  label,
  htmlFor,
  wide = false,
  children,
}: {
  label: string
  htmlFor: string
  wide?: boolean
  children: ReactNode
}) {
  return (
    <div className={wide ? 'adm-field adm-field-wide' : 'adm-field'}>
      <label htmlFor={htmlFor}>{label}</label>
      {children}
    </div>
  )
}

/** Etichetele ferestrelor de timp, ca in macheta. */
const WINDOW_LABELS: Record<number, string> = {
  1: 'Last 24 hours',
  7: 'Last 7 days',
  30: 'Last 30 days',
  90: 'Last 90 days',
}

export function windowLabel(days: number): string {
  return WINDOW_LABELS[days] ?? `Last ${days} days`
}

/** Fereastra de timp - ultimul camp al barei, `#admDays` in macheta. */
export function WindowPicker({
  windows,
  value,
  onChange,
}: {
  windows: number[]
  value: number
  onChange(days: number): void
}) {
  return (
    <AdmField label="Period" htmlFor="admDays">
      <select className="form-control input-sm" id="admDays" name="days" value={value} onChange={(e) => onChange(Number(e.target.value))}>
        {windows.map((w) => (
          <option key={w} value={w}>
            {windowLabel(w)}
          </option>
        ))}
      </select>
    </AdmField>
  )
}
